import DataTableBodyCellDetailsAddedManually from './DataTableBodyCellDetailsAddedManually';
import DataTableBodyCellDetailsPaidCoins from './DataTableBodyCellDetailsPaidCoins';
import DataTableBodyCellDetailsSendDm from './DataTableBodyCellDetailsSendDm';
import { CoinAddedByEnum, ProductsEnum } from '@/enums';
import { TableCellEmpty } from '@/components/custom';
import type { IUserTransaction } from '@/interfaces';
import { TableCell } from '@/components/ui';

type TProps = {
	transaction: IUserTransaction;
};

export const DataTableTransactionDetails = ({ transaction, showEmpty = true }: TProps & { showEmpty?: boolean }) => {
	if (transaction.product === ProductsEnum.PAID_COINS) {
		return <DataTableBodyCellDetailsPaidCoins transaction={transaction} />;
	} else if (transaction.product === ProductsEnum.SEND_DM) {
		return <DataTableBodyCellDetailsSendDm transaction={transaction} />;
	} else if (transaction.options?.coinsAddedBy === CoinAddedByEnum.MANUALLY) {
		return <DataTableBodyCellDetailsAddedManually transaction={transaction} />;
	}
	return showEmpty ? <TableCellEmpty text="Aucun détail supplémentaire" /> : null;
};

export const DataTableBodyCellDetails = ({ transaction }: TProps) => {
	return (
		<TableCell className="py-1 pe-0 w-0 text-nowrap">
			<DataTableTransactionDetails transaction={transaction} />
		</TableCell>
	);
};

export default DataTableBodyCellDetails;
